/* istanbul ignore file */
// not much value in testing providers
import { ThemeProvider as MuiThemeProvider } from '@mui/material/styles';
import { Theme } from '@mui/system';
import { ReactNode, useMemo } from 'react';
import { DeepPartial } from 'utility-types';

import { BAITheme } from '@bai/utils/types';

import { createTheme } from './createTheme';

export function ThemeProvider({
  children,
  useThemeOptions,
}: {
  children: ReactNode | ReactNode[];
  useThemeOptions: () => DeepPartial<BAITheme>;
}) {
  const themeOptions = useThemeOptions();
  const theme: Theme = useMemo(() => createTheme(themeOptions), [themeOptions]);
  return <MuiThemeProvider theme={theme}>{children}</MuiThemeProvider>;
}

export default ThemeProvider;
